import React, { useRef } from 'react';
import { Row, Column, IBox, Title, Content, Button } from '../inspinia';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { API_BASE_URL, TOASTER_SUCCESS } from '../../helpers/constants';
import { callApi } from '../../helpers/methods'


class AlteraSenha extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                'password': '',
                'confirm_password': ''
            },
            parametrosDaSenha : '',
            optionsGet: { method: 'GET' , headers: { 'Content-Type': 'application/json' } },
            endPoint: '/users/parametrosDaSenha',
        }

        this.handleLimparCampos = this.handleLimparCampos.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        
    }

    componentDidMount() {
        this.LoadParametros();
    }

    LoadParametros() {
        let self = this;
        const url = `${API_BASE_URL}${self.state.endPoint}`;
        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, parametrosDaSenha: response.message });
        });
    }

    handleLimparCampos() {
        this.setState({ ...this.state, form: { password: '', confirm_password: '' } });
    }

    handleChange(e) {
        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    handleSave() {
        let self = this;
        let url = `${API_BASE_URL}/users/trocaSenha`;

        const options = {
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({      
                password: self.state.form.password,
                confirm_password: self.state.form.confirm_password
            })
        }

        callApi(url, options, function() {
            self.handleLimparCampos();
            TOASTER_SUCCESS("Senha alterada com sucesso!");
        });
    }

    render() {
        return (
            <Column style={{display: 'flex',  justifyContent:'center'}}>
                <Column size="5">
                    <IBox>
                        <Title>
                            <h3 className="text-slate-grey">Troca de Senha</h3>
                        </Title>

                        <Content>
                            <Row className="m-auto">
                                <Column size="12" className=" mx-auto container">
                                    <Column>
                                        <div>
                                            <p>Por questões de segurança,a senha deve ser criada seguindo os requisitos abaixo: </p>
                                            <ul>
                                                <li>{this.state.parametrosDaSenha.split("| Regras vigentes:")[0]}</li>
                                                <li>{this.state.parametrosDaSenha.split("| Regras vigentes:")[1]}</li>
                                            </ul>
                                        </div>
                                    </Column>

                                    <Column>
                                        <div className="clearfix mb-1">
                                            <input type='password' value={this.state.form.password} className='form-control' name='password' onChange={this.handleChange} placeholder='Digite sua nova senha' ref='password' />
                                        </div>                           
                                        <div className="clearfix mb-2">
                                            <input type='password' value={this.state.form.confirm_password} className='form-control' name='confirm_password' onChange={this.handleChange} placeholder='Confirme sua nova senha' ref='confirmPassword' />
                                        </div>

                                        <div>
                                            <Button name='atualiza_senha' width='100%' onClick={this.handleSave}>Atualizar</Button>
                                        </div>
                                    </Column>       

                                </Column>
                            </Row>
                        </Content>
                    </IBox>
                </Column>
            </Column>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch) {
    return { actions: {} };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlteraSenha));